/** The latest Windows installer of the desktop app. */
export const DOWNLOAD_URL = 'https://github.com/SilentRush/pvplevelupapp/releases/latest/download/PvP-Levelup-Setup.exe';

export const downloadApp = () => window.open(DOWNLOAD_URL, '_blank');
